export default "__VITE_ASSET__B9o22Tls__"